<div class="card p-4 m-4" *ngIf="isShow">
  <div class="row">
    <div class="col-sm-5">
      <div id="servAddlistpn" class="container-fluid commonFormsCss">
        <h3>
          Add Services :
          <b> FNTESTA LNTESTA</b>
        </h3>
        <div class="mt-20">
          <input type="hidden" id="paxkey" name="paxkey" value="T2" />
          <input type="hidden" id="svcode" name="svcode" value="meal" />
          <div class="mt-20" *ngFor="let disabilityService of disabilityServiceDetails">
            <h4>
              Disability Assistance <b>{{ disabilityService.flightNumber }}</b>
            </h4>
            <div class="mt-10" style="position: relative">
              <img src="https://images.ctfassets.net/nwnmkeyu03hy/7cDuSOpG6XYpCBz8Ivu7O3/d3cda76ff87c6e402570ee53f076e17f/disability.JPG" class="selectIcon" />
              <select id="MEAL-T2-BA0256" name="MEAL-T2-BA0256" class="form-control fa-select fa fa-utensils">
                <option id="0" class="fa-align-left fa fa-utensils">No Disability Assistance</option>
                <option value="OFFER1-BA0256-MEAL" class="fa-align-left fa fa-utensils" *ngFor="let disabilityServiceDropdown of disabilityService.disabilityServicedropDownList">
                  {{ disabilityServiceDropdown.name }} | {{ disabilityService.flightNumber }} | {{ disabilityServiceDropdown.price }} USD
                </option>
              </select>
            </div>
          </div>
          <div style="right: 100px; margin-top: 30px" class="float-right">
            <button type="button" id="changebk" class="ba-btn ba-btn-sm-vthin pull-right" role="button" onclick="SaveService('POST');"><i class="fa fa-shopping-cart"></i> Save Service</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="position: absolute; top: 20px; right: 20px">
    <p (click)="servHide()" class="ba-btn ba-btn-sq-sm" role="button"><i class="fa fa-times"></i></p>
  </div>
</div>
